export const currentMilisecords = () => {
    return Date.now();
};

export const currentSecords = () => {
    return Math.floor(currentMilisecords() / 1000);
};

export const formatCustomStr = (
    time: string,
): string => {
    if (typeof time !== 'string' || !time) return '';
    const arr = time.split("-");
    return arr[2] + arr[1] + arr[0]
};

export const padZero = (num: number, size: number): string => {
    let s = String(num);
    while (s.length < size) {
        s = `0${s}`;
    }
    return s;
};

export const formatPlayerTime = (time: number): string => {
    time = Math.round(time);
    const minutes = padZero(Math.floor(time / 60), 1);
    const seconds = padZero(time % 60, 2);
    return `${minutes}:${seconds}`;
};

export const getDateFromNow = (currentDate: Date, num: number) => {
    const date = new Date(currentDate);
    date.setDate(date.getDate() + num);
    return date.getDate()
}

export const getDayFromNow = (currentDate: Date, num: number) => {
    const date = new Date(currentDate);
    date.setDate(date.getDate() + num);
    return convertDayToStr(date.getDay())
}

export const getTimeFromNow = (currentDate: Date, num: number) => {
    const date = new Date(currentDate);
    date.setDate(date.getDate() + num);
    return date;
}

export const convertDayToStr = (day: number) => {
    switch (day) {
        case 0:
            return 'CN';
        case 1:
            return 'Hai';
        case 2:
            return 'Ba';
        case 3:
            return 'Tư';
        case 4:
            return 'Năm';
        case 5:
            return 'Sáu';
        case 6:
            return 'Bảy';
        default:
            return ''
    }

}